import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--server-sortable-table"
// Minimal controller: only handles per-page changes via select.
// Sort links are plain <a> tags rendered server-side; Turbo handles frame updates natively.
export default class extends Controller {
  navigate(url) {
    const frame = this.element.closest("turbo-frame");
    if (frame) {
      window.Turbo?.visit(url, { frame: frame.id });
      history.pushState(null, "", url);
    } else {
      window.Turbo?.visit(url) || (window.location = url);
    }
  }

  changePerPage(event) {
    const url = new URL(window.location);
    url.searchParams.set("per_page", event.target.value);
    url.searchParams.delete("page");
    this.navigate(url.toString());
  }
}
